import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResourceService, DepreciacaoImovelItem } from 'eddydata-lib';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DepreciacaoImovelItemService extends BaseResourceService<DepreciacaoImovelItem> {

  constructor(
    protected injector: Injector
  ) {
    super(`depreciacao-imovel-itens`, injector);
  }

  public obterRelatorioDepreciacao(filtros?: any): Observable<any> {
    let parametros = '';
    if (filtros) {
      for (const key in filtros) {
        if (parametros === '') {
          parametros += '?';
        } else {
          parametros += '&';
        }
        parametros += key + '=' + filtros[key];
      }
    }

    return this.http.get<DepreciacaoImovelItem>(
      `${this.login.cidade.id}/${this.api}/relatorio-depreciacao${parametros}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}



